import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gfu-project-quickaction" }
const _hoisted_2 = { class: "gfu-navbar-item _screen--none _screen--flex-m" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-navbar-item gfu-navbar-item__button-wrapper _screen--none _screen--flex-m _pl-1 _mr-1"
}
const _hoisted_4 = {
  key: 0,
  class: "gfu-navbar-item gfu-navbar-item__button-wrapper _screen--none _screen--flex-m _pl-1 _pr-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cart_box = _resolveComponent("cart-box")
  const _component_share_link = _resolveComponent("share-link")
  const _component_share_facebook = _resolveComponent("share-facebook")
  const _component_follow_project_button = _resolveComponent("follow-project-button")
  const _component_back_project_button = _resolveComponent("back-project-button")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.showCart)
      ? (_openBlock(), _createBlock(_component_cart_box, {
          key: 0,
          class: "gfu-project-quickaction-cart"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_share_link),
            _createVNode(_component_share_facebook)
          ]),
          _createVNode(_Transition, { name: "gfu-shrink" }, {
            default: _withCtx(() => [
              ($options.isDraftPhase && !$options.userIsFollowingProject)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_ctx.projectContext.projectID)
                      ? (_openBlock(), _createBlock(_component_follow_project_button, {
                          key: 0,
                          "project-id": _ctx.projectContext.projectID,
                          "project-name": _ctx.projectContext.project.name,
                          "is-authenticated": _ctx.isAuthenticated,
                          "is-stacked": true,
                          section: "project-quick-action",
                          "show-overlay": false
                        }, null, 8 /* PROPS */, ["project-id", "project-name", "is-authenticated"]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          ($options.isBackProjectButtonVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_tooltip, {
                  text: _ctx.Resources.ProjectHome.CrowdfundingExpressUpgradeLimitationText,
                  enabled: !$options.canMakeAnotherPledge
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_back_project_button, {
                      disabled: !$options.canMakeAnotherPledge,
                      "is-stacked": ""
                    }, null, 8 /* PROPS */, ["disabled"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["text", "enabled"])
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}